import React, { useState } from "react";
import Marquee from "react-marquee-slider";
import Image from "next/image";

interface Person {
  id: number;
  name: string;
  role: string;
  picture: string;
}

interface PersonCardProps {
  person: Person;
}

const WeddingParty: React.FC = () => {
  const staticData: Person[] = [
    {
      id: 1,
      name: "Ifeoluwa Folami",
      role: "Maid of Honor",
      picture: "/images/weddingparty/moh.jpg",
    },
    {
      id: 2,
      name: "Timi Idowu",
      role: "Best Man",
      picture: "/images/weddingparty/bestman.jpg",
    },
    {
      id: 3,
      name: "Funmi Adeleke",
      role: "Bridesmaid",
      picture: "/images/weddingparty/bridesmaid.jpg",
    },
    {
      id: 4,
      name: "Olumide Santos",
      role: "Groomsman",
      picture: "/images/weddingparty/groomsman.jpg",
    },
    {
      id: 5,
      name: "Kemi Okafor",
      role: "Flower Girl",
      picture: "/images/weddingparty/flowergirl.jpg",
    },
  ];

  const PersonCard: React.FC<PersonCardProps> = ({ person }) => (
    <div className="w-72 mx-4 overflow-hidden  cursor-pointer">
      <Image
        src={person.picture}
        alt={person.name}
        width={600}
        height={700}
        className="w-full h-96 object-cover"
      />
      <div className="p-4 text-center text-[#FCE2B0]">
        <h3 className="text-xl font-ntFab tracking-wide uppercase">
          {person.name}
        </h3>
        <p className="text-base font-ebGaramond italic">{person.role}</p>
      </div>
    </div>
  );

  return (
    <div className="w-full bg-[linear-gradient(180deg,_#00234B_0%,_#002D60_100%)] py-16">
      <div className="text-center flex flex-col justify-center mb-12">
        <h1 className="text-3xl sm:text-5xl font-ntFab text-[#FCE2B0] mb-4">
          The Wedding Party
        </h1>
        <p className="sm:text-xl font-ebGaramond text-[#FCE2B0] w-full max-w-[85%] px-4 sm:max-w-2xl mx-auto text-center">
          Meet the amazing people who will celebrate this special day with us.
        </p>
      </div>

      {/* Single Marquee Row - All Members */}
      <div style={{ maxWidth: "100vw", width: "100%" }}>
        <Marquee
          velocity={25}
          direction="ltr"
          scatterRandomly={false}
          resetAfterTries={200}
          onInit={() => null}
          onFinish={() => null}
        >
          {staticData.map((person) => (
            <PersonCard key={person.id} person={person} />
          ))}
        </Marquee>
      </div>
    </div>
  );
};

export default WeddingParty;
